import { convertToFieldArray } from "../utils/helpers";

import useEvercookie from "../pages/tools/CheckEvercookie/useEvercookie";

const useInfoFromBrowser = () => {
  const { uid } = useEvercookie();

  const setAllFields = value => {
    return {
      "HTTP Cookies": value,
      "HTTP ETags": value,
      "HTTP Cache": value,
      "HTML5 Local Storage": value,
      "HTML5 Global Storage": value,
      "HTML5 Session Storage": value,
      "HTML5 Database Storage via SQLite": "N/A",
      "HTML5 IndexedDB": value,
      "HTML5 PNG Caching": value,
      "window.name Caching": value,
      "Flash Cookies": "N/A",
      "Silverlight Storage": "N/A",
      "IE userData": "N/A",
    };
  };

  const result = convertToFieldArray(uid, setAllFields);

  return { result };
};

export default useInfoFromBrowser;
